import React from "react";
import CustomCursor from '../../Global/Cursor';
import Preloader from '../../Global/Preloader'
import Header from "../../Global/Header1";
import PageHeader from "../MenPricing/PageHeader";
import PricingOne from "../MenPricing/PricingOne";
import FaqFour from "../MenCareers/FaqFour";
import CtaTwo from "../../Global/Cta";
import Footer from "../../Global/Footer1";
import GoToTop from "../../Global/GoToTop";
const Main = () => {
    return (
        <>
            <CustomCursor />
            <Preloader />
            <Header />
            <PageHeader />
            <PricingOne />
            <FaqFour />
            <CtaTwo />
            <Footer />
            <GoToTop />
        </>
    )
}
export default Main;